import React, { Component } from 'react'
import { Map } from 'immutable'
import PropTypes from 'prop-types'
import { connect as connectRedux } from 'react-redux'
import { getBoundActions } from '../../actions/index'
import { SUBSCRIPTION_TYPES } from '../../services/notifications/index'
import {
  SERIES_FOLLOWED_GA4_EVENT,
  SERIES_UNFOLLOWED_GA4_EVENT,
} from '../../services/event-tracking/index'
import { NotificationsBell, BELL_TYPES } from '../NotificationsBell/index'
import IconV2, { ICON_TYPES } from '../Icon.v2/index'
import Button, { TYPES } from '../Button/index'
import Bell from '../Icon/icons/Bell/index'
import BellOff from '../Icon/icons/BellOff/index'

export const BUTTON_TYPES = {
  PRIMARY_SMALL: 'PRIMARY_SMALL',
  SECONDARY: 'SECONDARY',
  PRIMARY: 'PRIMARY',
  PILL: 'PILL',
  LINK: 'LINK',
  ROUND: 'ROUND',
  ROUND_SVG: 'ROUND_SVG',
}

class FollowButton extends Component {
  //
  constructor (props) {
    super(props)
    this.state = {
      focused: false,
    }
  }

  componentDidMount () {
    const { props } = this
    const {
      contentId,
      subscriptionType,
      getSubscribableEntity,
    } = props
    getSubscribableEntity({
      type: subscriptionType,
      contentId,
    })
  }
  // TODO: add back later
  // there is a bug when multiple components use the same
  // subscription entity and one of them unmounts
  // componentWillUnmount () {
  //   const { props } = this
  //   const {
  //     contentId,
  //     subscriptionType,
  //     clearSubscribableEntity,
  //   } = props
  //   clearSubscribableEntity({
  //     type: subscriptionType,
  //     contentId,
  //   })
  // }

  onFocus = () => {
    this.setState(() => ({
      focused: true,
    }))
  }

  onBlur = () => {
    this.setState(() => ({
      focused: false,
    }))
  }

  onFollow = () => {
    const { props } = this
    const {
      subscription,
      subscriptionType,
      removeSubscriber,
      createSubscriber,
      setEventDefault,
      contentId,
      uiLocation,
      uiElement,
    } = props
    const isSubscribed = subscription.get('subscriber')
    const contentName = subscription.get('contentTitle')
    const contentType = subscription.get('contentType')

    if (isSubscribed) {
      const eventData = SERIES_UNFOLLOWED_GA4_EVENT
        .mergeDeep({
          content_id: contentId,
          content_name: contentName,
          content_type: contentType,
          ui_location: uiLocation,
          ui_element: uiElement,
        })

      removeSubscriber(subscription)

      // only send GA4 event for series for now...
      if (subscriptionType === SUBSCRIPTION_TYPES.SERIES) {
        setEventDefault(eventData)
      }
    } else {
      const eventData = SERIES_FOLLOWED_GA4_EVENT
        .mergeDeep({
          content_id: contentId,
          content_name: contentName,
          content_type: contentType,
          ui_location: uiLocation,
          ui_element: uiElement,
        })

      createSubscriber(subscription)

      // only send GA4 event for series for now...
      if (subscriptionType === SUBSCRIPTION_TYPES.SERIES) {
        setEventDefault(eventData)
      }
    }
  }

  getIcon () {
    const { props, state } = this
    const { type, disableHover = false } = props
    const { subscription } = props
    const isSubscribed = subscription.get('subscriber')
    const { focused } = state
    const subscribedAndFocused = isSubscribed && (focused || disableHover)

    switch (type) {
      case BUTTON_TYPES.PILL:
      case BUTTON_TYPES.ROUND:
        return <IconV2 type={subscribedAndFocused
          ? ICON_TYPES.BELL_OFF
          : ICON_TYPES.BELL} />
      case BUTTON_TYPES.LINK:
        return (
          <IconV2
            className="episode-button"
            type={isSubscribed
              ? ICON_TYPES.CIRCULAR_BELL_OFF
              : ICON_TYPES.CIRCULAR_FOLLOW_BELL
            }
          />
        )
      case BUTTON_TYPES.ROUND_SVG:
        return subscribedAndFocused ? <BellOff /> : <Bell />
      default:
        return (
          <NotificationsBell
            type={BELL_TYPES.STROKE_HEAVY}
            fill="#ffffff"
            size={19}
          />
        )
    }
  }

  getRootClass () {
    const { props } = this
    const { type } = props
    switch (type) {
      case BUTTON_TYPES.SECONDARY:
        return 'nfb nfb--block'
      default:
        return 'nfb'
    }
  }

  getButtonClass () {
    const { props } = this
    const { type } = props
    const { subscription } = props
    const isSubscribed = subscription.get('subscriber')

    switch (type) {
      case BUTTON_TYPES.PRIMARY:
        return 'nfb__primary'
      case BUTTON_TYPES.PRIMARY_SMALL:
        return 'nfb__primary-small'
      case BUTTON_TYPES.SECONDARY:
        return 'nfb__secondary'
      case BUTTON_TYPES.LINK:
        return 'nfb__link'
      case BUTTON_TYPES.PILL:
        return isSubscribed
          ? 'nfb__pill--following'
          : 'nfb__pill--not-following'
      case BUTTON_TYPES.ROUND:
      case BUTTON_TYPES.ROUND_SVG:
        return 'nfb__round'
      default:
        return ''
    }
  }

  getMemberLabel () {
    const { props, state } = this
    const { staticText, subscription, disableHover = false } = props
    const isSubscribed = subscription.get('subscriber')
    const { focused } = state

    if (isSubscribed && (focused || disableHover)) {
      return staticText.getIn(['data', 'unfollow'])
    }

    return isSubscribed
      ? staticText.getIn(['data', 'following'])
      : staticText.getIn(['data', 'follow'])
  }

  getTermLabel () {
    const { props, state } = this
    const {
      title, type, staticText, subscription, disableHover = false,
    } = props
    const isSubscribed = subscription.get('subscriber')
    const isSmall = type === BUTTON_TYPES.PRIMARY_SMALL
    const labelTitle = isSmall ? '' : ` ${title}`
    const { focused } = state

    let label = staticText.getIn(['data', 'follow'])

    if (isSubscribed || disableHover) {
      label = focused
        ? staticText.getIn(['data', 'unfollow'])
        : staticText.getIn(['data', 'following'])
    }
    return `${label}${isSmall ? '' : labelTitle}`
  }

  getSeriesLabel () {
    const { props, state } = this
    const {
      type,
      staticText,
      subscription,
      disableHover = false,
    } = props
    const isSubscribed = subscription.get('subscriber')
    const isSmall = type === BUTTON_TYPES.PRIMARY_SMALL
    const { focused } = state

    if (isSubscribed) {
      if (isSmall) {
        return focused || disableHover
          ? staticText.getIn(['data', 'unfollow'])
          : staticText.getIn(['data', 'following'])
      }
      return focused || disableHover
        ? staticText.getIn(['data', 'unfollowSeries'])
        : staticText.getIn(['data', 'followingSeries'])
    }
    return staticText.getIn(['data', 'followSeries'])
  }

  getGuideLabel () {
    const { props, state } = this
    const {
      type,
      staticText,
      subscription,
      disableHover = false,
    } = props
    const isSubscribed = subscription.get('subscriber')
    const isSmall = type === BUTTON_TYPES.PRIMARY_SMALL
    const { focused } = state

    if (isSubscribed) {
      if (isSmall) {
        return focused || disableHover
          ? staticText.getIn(['data', 'unfollow'])
          : staticText.getIn(['data', 'following'])
      }
      return focused || disableHover
        ? staticText.getIn(['data', 'unfollowGuide'])
        : staticText.getIn(['data', 'followingGuide'])
    }
    return staticText.getIn(['data', 'followGuide'])
  }

  getLabel () {
    const { props } = this
    const { subscription } = props
    const type = subscription.get('type')
    switch (type) {
      case SUBSCRIPTION_TYPES.GUIDE:
        return this.getGuideLabel()
      case SUBSCRIPTION_TYPES.SERIES:
        return this.getSeriesLabel()
      case SUBSCRIPTION_TYPES.MEMBER:
        return this.getMemberLabel()
      case SUBSCRIPTION_TYPES.TERM:
        return this.getTermLabel()
      default:
        return null
    }
  }

  render () {
    const { props } = this
    const { subscription, noLabel } = props
    const isSubscribable = subscription.get('isSubscribable')

    if (!isSubscribable) {
      return null
    }

    return (
      <div className={this.getRootClass()}>
        <Button
          type={TYPES.DEFAULT}
          className={this.getButtonClass()}
          onMouseOver={this.onFocus}
          onMouseOut={this.onBlur}
          onClick={this.onFollow}
          onFocus={this.onFocus}
          onBlur={this.onBlur}
        >
          <span className="nfb__text">
            <span
              className="nfb__bell"
              role="presentation"
              title={noLabel ? this.getLabel() : null }
            >{this.getIcon()}
            </span>
            {!noLabel ? this.getLabel() : null}
          </span>
        </Button>
      </div>
    )
  }
}

FollowButton.propTypes = {
  subscriptionType: PropTypes.string.isRequired,
  contentId: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]).isRequired,
  type: PropTypes.string.isRequired,
  title: PropTypes.string,
  disableHover: PropTypes.bool,
  setEventDefault: PropTypes.func,
  uiLocation: PropTypes.string,
  uiElement: PropTypes.string,
}

const connected = connectRedux(
  (state, props) => {
    const { subscriptionType, contentId } = props
    const staticText = state.staticText.getIn(['data', 'NotificationsFollowButton'])
    const subscription = state.notifications.getIn(['subscribables', subscriptionType, contentId], Map())
    return { subscription, staticText }
  },
  (dispatch) => {
    const actions = getBoundActions(dispatch)
    return {
      clearSubscribableEntity: actions.notifications.clearSubscribableEntity,
      getSubscribableEntity: actions.notifications.getSubscribableEntity,
      removeSubscriber: actions.notifications.removeSubscriber,
      createSubscriber: actions.notifications.createSubscriber,
      setEventDefault: actions.eventTracking.setEventDefault,
    }
  },
)(FollowButton)

export const NotificationsFollowButton = connected
